module.exports = __webpack_public_path__ + "static/media/simon.84a0152c.jpg";